<template>
  <div class="dimmer" id="dimmer_loading">
    <div class="dimmer-inner">
      <div class="dimmer-icon">
        <div class="progress-spinner progress-spinner-active">
          <span class="visually-hidden">Caricamento...</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// @ts-ignore
import {Dimmer} from 'bootstrap-italia'
import {onMounted, watch} from "vue";
import {useLoadingSpinnerStore} from "@/stores/loadingSpinner";

onMounted(() => {
  const myDimmer = document.getElementById('dimmer_loading')
  const dimmer = new Dimmer(myDimmer)
  dimmer.hide()

  const loadingSpinnerStore = useLoadingSpinnerStore();
  watch(loadingSpinnerStore.loading, (value: Map<string, boolean>) => {
    if(!!dimmer){
      const inLoading = [...value.values()].some((el) => el);
      inLoading ? dimmer.show() : dimmer.hide();
    }
  }, {deep: true})

})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dimmer {
  background-color: rgba(31, 41, 51, 0.59) !important;
  z-index: 9999999 !important;
}

.dimmer-inner {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
}
</style>
